<template>
  <div class="flex flex-col sign-up-page bg-grey-background-subdued">
    <corporate-header :logo-image-url="corporateClient.logoImageURL" :slug="slug" :corporate-client-name="corporateClient.name" />
    <generic-error v-if="hasError" title="We couldn’t find that page" class="mt-64" />
    <div v-else class="mb-36 md:mb-60">
      <card class="invisible md:visible block mx-auto mt-36 md:mt-60 sign-up-card">
        <sign-up-form
          :leadid="$route.query.leadid"
          :termsOfUseLink="termsOfUseLink"
          :isYearsAhead="isYearsAhead"
          :slug="slug"
          :privacyPolicyLink="privacyPolicyLink"
          :corporateClient="corporateClient"
          :logInLink="logInLink"
          class="visible"
        />
      </card>
      <div v-if="!isYearsAhead" class="trust-and-safety-sign-up mx-16">
        <p class="px-16 py-16">
          All users are encouraged to visit our
          <a class="underline" target="_blank" href="https://www.sittercity.com/trust-and-safety">Trust & Safety Center</a> to
          learn more about our commitment to keeping you safe.
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Card from '@/components/card/Card.vue';
import CorporateHeader from './components/CorporateHeader.vue';
import { CORPORATE_SIGNUP_FORM_QUERY } from '../../graphql/bh_benefits/queries';
import SignUpForm from './components/SignUpForm.vue';
import GenericError from '@/components/generic_error/GenericError.vue';

export default {
  name: 'SignUp',
  components: { CorporateHeader, Card, SignUpForm, GenericError },
  data(): any {
    return {
      hasError: false,
      corporateClient: {},
      isYearsAhead: false,
      signUpForm: {
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        zipCode: '',
        isTermsOfServiceAccepted: false,
      },
    };
  },
  computed: {
    slug(): string {
      return this.$route.params.slug;
    },
    termsOfUseLink(): string {
      return this.isYearsAhead ? 'https://www.yearsahead.com/content/terms-of-use/ ' : '/terms';
    },
    privacyPolicyLink(): string {
      return this.isYearsAhead ? 'https://www.yearsahead.com/content/privacy-policy/ ' : '/privacy';
    },
    logInLink(): string {
      return this.isYearsAhead ? 'https://www.yearsahead.com/seeker/login' : `/login?company_slug=${this.slug}`;
    },
  },
  mounted() {
    if (this.$route.query.site === 'years_ahead') {
      this.isYearsAhead = true;
    }
  },
  apollo: {
    corporateClient: {
      query: CORPORATE_SIGNUP_FORM_QUERY,
      variables() {
        return {
          slug: this.$route.params.slug,
        };
      },
      result({ data }) {
        if (data && data.corporateClient && data.corporateClient.isActive) {
          this.corporateClient = data.corporateClient;
        } else {
          this.hasError = true;
        }
      },
    },
  },
};
</script>
